import Confirmation from '../../../../components/Settings/Communications/Confirmation';
import Disclosure from '../../../../components/Settings/Communications/Disclosure';
import PaperlessForm from '../../../../components/Settings/Communications/PaperlessForm';

const VIEW_DICTIONARY = { 1: PaperlessForm, 2: Disclosure, 3: Confirmation };

export default VIEW_DICTIONARY;
